import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import { EnhancedScopeData } from '@ardoq/data-model';
import { enhancedScopeDataOperations } from '@ardoq/scope-data';
import { ComponentSuggestionWithBreadcrumbs } from '@ardoq/suggestions-api';
import {
  InventoryReferenceRepresentation,
  ReferenceColumnDirection,
} from './types';

type ReferenceResolutionParams = {
  scopeData: EnhancedScopeData;
  editedComponent: APIComponentAttributes;
  referencedComponentId: ArdoqId;
  direction: ReferenceColumnDirection;
  referenceTypeName: string;
  componentSuggestions?: ComponentSuggestionWithBreadcrumbs[];
};

/**
 * `type` is the reference type id in the model that owns the reference, which
 * is the source's. For an incoming reference that is the pasted component's
 * model, which need not be loaded, so the id can be unresolved here.
 */
export const toInventoryReferenceRepresentation = ({
  scopeData,
  editedComponent,
  referencedComponentId,
  direction,
  referenceTypeName,
  componentSuggestions = [],
}: ReferenceResolutionParams): InventoryReferenceRepresentation => {
  if (direction === 'outgoing') {
    return {
      source: editedComponent._id,
      target: referencedComponentId,
      type: enhancedScopeDataOperations.getReferenceTypeIdBySourceModelIdAndReferenceTypeName(
        scopeData,
        editedComponent.model,
        referenceTypeName
      ),
      direction,
    };
  }

  return {
    source: referencedComponentId,
    target: editedComponent._id,
    type:
      enhancedScopeDataOperations.getReferenceTypeIdBySourceComponentId(
        scopeData,
        referencedComponentId,
        referenceTypeName
      ) ||
      componentSuggestions.find(
        suggestion => suggestion.value === referencedComponentId
      )?.referenceTypeId,
    direction,
  };
};
